import { render, staticRenderFns } from "./veStuPunishCount.vue?vue&type=template&id=c81ae89a&scoped=true"
import script from "./veStuPunishCount.vue?vue&type=script&lang=js"
export * from "./veStuPunishCount.vue?vue&type=script&lang=js"
import style0 from "./veStuPunishCount.vue?vue&type=style&index=0&id=c81ae89a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81ae89a",
  null
  
)

export default component.exports